/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum GeneratedProjectDescriptionStatus {

    READY = 'READY',

    NOT_GENERATED = 'NOT_GENERATED'
}

